<template>
  <div
    id="home"
    class=""
  >
    <!-- 视频 -->
    <div
      id="id-home-bg"
      class="home-bg"
      :style="bgStyle"
    >
      <!-- 播放按钮图 -->
      <img
        src="../assets/images/play.png"
        class="home-play-btn"
        :style="showVideoBtn"
      />
      <!-- 播放按钮的遮罩 -->
      <div
        class="home-play-hexagon"
        @click="showVideo = true"
        :style="showVideoBtn"
      ></div>

      <!-- 标题、副标题 -->
      <div class="title">
        <img
          :src="mainTitle"
          class="title-main"
          :style="newMainTitleStyle"
        />
        <img
          :src="subTitle"
          class="title-sub"
          :style="newSubTitleStyle"
        />
      </div>

      <!-- 下载按钮 -->
      <div class="shop">
        <a
          v-for="link, idx in links[this.$i18n.locale]"
          :key="idx"
          :href="link.href"
          target="_blank"
        >
          <img
            :src="link.icon"
            class="shop-img"
          />
        </a>
      </div>
    </div>

    <!-- HomeVideo -->
    <div
      class="video-modal"
      v-if="showVideo"
    >
      <div
        class="modal-mask"
        @click="closeVideo"
      ></div>
      <div class="modal-content">
        <video
          id="id-homevideo"
          ref="videoPlayer"
          :src="getHomeVideoUrl"
          controls
          autoplay
          loop
          volume="0.5"
          class="modal-video"
        ></video>
      </div>
    </div>

    <!-- 审查 censor -->
    <div class="censor">
      <img
        v-show="this.$i18n.locale == 'zh'"
        src="../assets/images/202510/home/censor/zh.png"
        class="censor-img"
      />
      <img
        v-show="this.$i18n.locale == 'en'"
        src="../assets/images/202510/home/censor/en.png"
        class="censor-img"
      />
      <img
        v-show="this.$i18n.locale == 'en'"
        src="../assets/images/202510/home/censor/en1.png"
        class="censor-img2"
      />
      <img
        v-show="this.$i18n.locale == 'ja'"
        src="../assets/images/202510/home/censor/ja-new.svg"
        class="censor-img"
      />
    </div>

    <div class="logo">
      <img
        src="../assets/images/202510/home/censor/logo.png"
        class="logo-img"
      />
    </div>

    <div class="copyright-info">
      <span>© ARC SYSTEM WORKS / © 91Act. Developed by 91Act. Published by Astrolabe Games & 91Act. All rights reserved.</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 定时更换背景图
      switchTime: "2026-02-12 00:00:00",
      oldBgUrl: require("../assets/images/202510/home/bg.png"),
      newBgUrl: require("../assets/images/202602/home/bg.png"),
      timer: null,
      hasSwitched: false,
      // 视频弹窗
      showVideo: false,
      links: {
        zh: [
          { icon: require(`../assets/images/202510/home/shop/${this.$i18n.locale}/ps.png`), href: "https://store.playstation.com/zh-hans-hk/concept/10013958" },
          { icon: require(`../assets/images/202510/home/shop/${this.$i18n.locale}/ns.png`), href: "https://ec.nintendo.com/HK/zh/titles/70010000105929" },
          { icon: require(`../assets/images/202602/shop/xbox.png`), href: "https://www.xbox.com/en-US/games/store/blazblue-entropy-effect-x/9n8h4rrsrv2s/" }
        ],
        en: [
          { icon: require(`../assets/images/202510/home/shop/${this.$i18n.locale}/ps.png`), href: "https://store.playstation.com/en-us/concept/10013958" },
          { icon: require(`../assets/images/202510/home/shop/${this.$i18n.locale}/ns.png`), href: "https://www.nintendo.com/us/store/products/blazblue-entropy-effect-x-switch/" },
          { icon: require(`../assets/images/202602/shop/xbox.png`), href: "https://www.xbox.com/en-US/games/store/blazblue-entropy-effect-x/9n8h4rrsrv2s/" }
        ],
        ja: [
          { icon: require(`../assets/images/202510/home/shop/${this.$i18n.locale}/ps.png`), href: "https://store.playstation.com/ja-jp/concept/10013958" },
          { icon: require(`../assets/images/202510/home/shop/${this.$i18n.locale}/ns.png`), href: "https://store-jp.nintendo.com/item/software/D70010000105928" },
          { icon: require(`../assets/images/202602/shop/xbox.png`), href: "https://www.xbox.com/en-US/games/store/blazblue-entropy-effect-x/9n8h4rrsrv2s/" }
        ]
      }
    }
  },
  methods: {
    closeVideo() {
      this.showVideo = false
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause()
      }
    },
    getTimeDiff() {
      // 目标时间
      const targetTime = new Date(this.switchTime).getTime()
      // 当前时间
      const nowTime = new Date().getTime()
      return targetTime - nowTime
    },
    initBgSwitchTimer() {
      const timeDiff = this.getTimeDiff()

      // 4. 判断是否需要设置定时器
      if (timeDiff <= 0) {
        // 如果当前时间已过指定时间，直接切换
        this.switchBgAndTitle()
      } else {
        // 否则设置单次定时器，到点后切换
        this.timer = setTimeout(() => {
          this.switchBgAndTitle()
        }, timeDiff)
      }
    },
    switchBgAndTitle() {
      if (!this.hasSwitched) {
        this.hasSwitched = true
      }
    }
  },
  computed: {
    timeDiff() {
      const targetTime = new Date(this.switchTime).getTime()
      const nowTime = new Date().getTime()
      return targetTime - nowTime
    },
    bgStyle() {
      return {
        background: `url("${this.hasSwitched ? this.newBgUrl : this.oldBgUrl}") no-repeat center center / cover`,
        width: "100%",
        height: "100%"
      }
    },
    showVideoBtn() {
      return this.hasSwitched
        ? {
          display: "none",
        }
        : ""
    },
    newMainTitleStyle() {
      return this.hasSwitched
        ? {
          position: "absolute",
          // 核心修改：用vw替代固定px，height:auto保持宽高比
          // width: "36.5vw", // 584px 对应 1920px 视口的 36.5vw（584/1920≈0.365）
          maxWidth: "584px", // 限制最大宽度，避免大屏下过大
          height: "auto", // 自动计算高度，保持图片原始宽高比
          bottom: "12.5vw", // 底部距离也改用vw，适配不同视口
          left: "50%", // 可选：居中对齐（如果需要）
          transform: "translateX(-50%)" // 可选：配合left:50%实现水平居中
        }
        : ""
    },
    newSubTitleStyle() {
      return this.hasSwitched
        ? {
          position: "absolute",
          // 同理：根据subTitle的原始尺寸换算vw，示例值请根据实际调整
          // width: "28vw",
          // maxWidth: "450px", // 替换为subTitle的最大宽度
          height: "auto",
          bottom: "4.3vw", // 适配底部距离
          left: "50%",
          transform: "translateX(-50%)"
        }
        : ""
    },
    mainTitle() {
      const locale = this.$i18n.locale
      return this.hasSwitched
        ? require(`../assets/images/202602/title/${locale}/main.png`)
        : require(`../assets/images/202510/home/title/${locale}/main.png`)
    },
    subTitle() {
      const locale = this.$i18n.locale
      return this.hasSwitched
        ? require(`../assets/images/202602/title/${locale}/sub.png`)
        : require(`../assets/images/202510/home/title/${locale}/sub.png`)
    },
    getHomeVideoUrl() {
      return `https://bbeex.91act.com/videos/pv-${this.$i18n.locale}.webm`
    }
  },
  mounted() {
    this.initBgSwitchTimer()
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
}
</script>

<style scoped lang="scss">
#home {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 99;
}

.home-bg {
  width: 100%;
  height: 100%;
}

.home-play-btn {
  width: 480px;
  height: 104px;
  position: absolute;
  left: 50%;
  top: calc(50% - 120px);
  transform: translateX(-49%) scale(0.85) translate(0.5rem, 0.5rem);
  z-index: 100;
}

.home-play-hexagon {
  width: 95px;
  height: 83px;
  position: absolute;
  left: 50%;
  top: calc(50% - 110px);
  transform: translateX(-45%) translate(0.5rem, 0.5rem);
  clip-path: polygon(75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%, 25% 0%);
  z-index: 101;
  cursor: pointer;
}

.video-modal {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

.modal-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  position: absolute;
  z-index: 1001;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.modal-video {
  max-width: 1024px;
  max-height: 720px;
}

.title {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.title-main {
  position: absolute;
  width: 1014px;
  height: 188px;
  bottom: 21%;
}

.title-sub {
  position: absolute;
  width: 1145px;
  height: 43px;
  bottom: 18%;
}

.shop {
  position: absolute;
  display: inline-flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  bottom: 0;
  transform: translateY(-60%);
  z-index: 300;
}

.shop-img {
  width: 202px;
  max-height: 93px;
}

.censor {
  width: auto;
  height: 59px;
  bottom: 50px;
  left: 20px;
  position: absolute;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.censor-img {
  width: 36px;
  height: 46px;
  padding-right: 10px;
}

.censor-img2 {
  width: 103px;
  height: 46px;
  padding-right: 3px;
}

.logo {
  width: auto;
  height: 30px;
  position: absolute;
  bottom: 65px;
  right: 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  z-index: 30;
}

.logo-img {
  width: 101px;
  height: 30px;
}

.copyright-info {
  width: 100%;
  height: auto;
  color: #adaeb5;
  position: absolute;
  bottom: 25px;
  left: 20px;
  font-size: 15px;

  font-size: 14px;
  font-family: "MiSans-Medium";
}
</style>
